import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import { AdminModule } from '@/store/modules/admin';
import { ACCOUNT_MANAGER, ADMIN, INVOICE_MANAGER, ORDER_MANAGER, PAYMENT_MANAGER, READ_ONLY, REGIONAL_MANAGER, BRANCH_MANAGER, SUPER_ADMIN, UNIT_MANAGER, ZONAL_MANAGER } from './constants/roles.constants';
import { getDealers } from './api/dealers';
import { getQuery } from './utils';
import { getAdmins } from './api/admins';
export function isExcludedToAccess(requiredRoles) {
  // const requiredRoles = [3, 4]; // 3-> unit manager , 4-> Invoice manager
  return !requiredRoles.some(roleId => AdminModule.adminsRoleIds.includes(roleId));
}
export function findRoleCurrentlyLoggedIn(requiredRoles) {
  return requiredRoles.some(roleId => AdminModule.adminsRoleIds.includes(roleId));
}
export function isSuperAdmin() {
  return findRoleCurrentlyLoggedIn([SUPER_ADMIN]);
}
export function isAdmin() {
  return findRoleCurrentlyLoggedIn([ADMIN]);
}
export function isUnitManager() {
  return findRoleCurrentlyLoggedIn([UNIT_MANAGER]);
}
export function isInvoiceManager() {
  return findRoleCurrentlyLoggedIn([INVOICE_MANAGER]);
}
export function isInvoiceAndUnitManager() {
  return isInvoiceManager() && isUnitManager();
}
export function isReadOnly() {
  return findRoleCurrentlyLoggedIn([READ_ONLY]);
}
export function isAccountManager() {
  return findRoleCurrentlyLoggedIn([ACCOUNT_MANAGER]);
}
export function isOrderManager() {
  return findRoleCurrentlyLoggedIn([ORDER_MANAGER]);
}
export function isRegionalManager() {
  return findRoleCurrentlyLoggedIn([REGIONAL_MANAGER]);
}
export function isZonalManager() {
  return findRoleCurrentlyLoggedIn([ZONAL_MANAGER]);
}
export function isBranchManager() {
  return findRoleCurrentlyLoggedIn([BRANCH_MANAGER]);
}
export function isPaymentManager() {
  return findRoleCurrentlyLoggedIn([PAYMENT_MANAGER]);
}
export function isValidPhoneNumber(phoneNumber) {
  const phoneRegex = /^[0-9]{10}$/;
  return phoneRegex.test(phoneNumber);
}
// create function that checks if the deakerId provided exists in the depo is list
export async function isBranchDispatch(dealerId) {
  // Fetch dealers
  const data = await getDealers(getQuery({
    isUnit: true,
    filter: {
      isUnit: '$eq'
    }
  }));
  // Extract only IDs
  const ids = data.map(d => d.id);
  return ids.includes(dealerId);
}
export function cleanListQuery(listQuery) {
  if (typeof listQuery.branchId === 'string' && listQuery.branchId.length === 0) {
    delete listQuery.branchId;
  }
  if (listQuery.dealerId === undefined || typeof listQuery.dealerId === 'undefined') {
    delete listQuery.dealerId;
  }
  return listQuery; // Return the cleaned object
}
export async function checkIsPrimaryAccountManager(id) {
  try {
    const query = {
      enabled: true,
      filter: {
        enabled: '$eq'
      }
    };
    const data = await getAdmins(getQuery(query));
    const list = data.data;
    // Filter out those data where adminsRoleId is 6
    const filteredData = list.filter(item => item.adminsRole && item.adminsRole.some(role => role.id === 6));
    // Check if the id is present in filtered data
    const admin = filteredData.find(item => item.id === id);
    // If present, check if isPrimary is true
    if (admin) {
      return admin.isPrimary === true;
    }
    return false;
  } catch (error) {
    console.error('Error checking primary account manager:', error);
    return false;
  }
}